import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ permission = 'app:access' }) {
  const { isAuthenticated, isReady, can, sessionError } = useAuth();
  const location = useLocation();

  if (!isReady) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location, authError: sessionError }} />;
  }

  if (sessionError || !can(permission)) {
    return (
      <Navigate to="/logout" replace state={{
        from: location,
        authError: sessionError || 'You do not have access to this page.',
      }} />
    );
  }

  return <Outlet />;
}

export default ProtectedRoute;
